/**
 * A safe and ESLint-compatible way to check if an object contains a property.
 *
 * {@link https://eslint.org/docs/rules/no-prototype-builtins}
 * {@link https://eslint.org/docs/rules/guard-for-in}
 * {@link https://github.com/eslint/eslint/issues/7071}
 *
 * @param {Object} obj  The object to check.
 * @param {string} prop The to check.
 *
 * @returns {boolean} True if the property exists.
 */
export default (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
